export default __webpack_public_path__ + "static/media/black_dot.2a087ee0.svg";